export function isEmptyEducation(data) {
    const { institution, specialization, from, to } = data;
    return !institution || !specialization || !from || !to;
}
